import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnimateHeight from 'react-animate-height'
import CustomAlert from '../../../Components/Alert'
import fetchApiError from '../../../Helpers/fetchApiError'
import { useForm } from '../../../Hooks/useForm'
import TrackingService from '../../../Services/Tracking'
import './styles.scss'

const Tracker = ({ setTrackItResult }) => {
  const { form, onChange } = useForm({
    trackingNumber: '',
    loading: false,
    error: null,
  })

  const getDetails = async (num) => {
    onChange('loading', true)
    onChange('error', null)

    try {
      const res = await TrackingService.get_by_tracking_number(num)
      setTrackItResult(res.data.data)
    } catch (error) {
      setTrackItResult(null)
      onChange('error', fetchApiError(error))
    }

    onChange('loading', false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    getDetails(form.trackingNumber)
  }

  return (
    <div className="tracker">
      <div className="tracker__card">
        <div className="tracker__icon-wrap">
          <FontAwesomeIcon icon={solid('box')} />
        </div>

        <h2 className="tracker__title">Track Your Shipment</h2>
        <p className="tracker__subtitle">
          Enter your tracking number to get real-time updates on your package location and status.
        </p>

        <form onSubmit={handleSubmit} className="tracker__form">
          <div className="tracker__input-wrap">
            <FontAwesomeIcon className="tracker__input-icon" icon={solid('magnifying-glass')} />
            <input
              type="text"
              className="tracker__input"
              placeholder="Enter tracking number or Air Waybill #"
              value={form.trackingNumber}
              onChange={(e) => onChange('trackingNumber', e.target.value)}
              required
            />
          </div>

          <AnimateHeight duration={300} height={form.error ? 'auto' : 0}>
            <div style={{ paddingTop: '4px' }}>
              <CustomAlert variant="danger" message={form.error} />
            </div>
          </AnimateHeight>

          <button type="submit" className="tracker__btn" disabled={form.loading}>
            {form.loading ? (
              <>
                <FontAwesomeIcon icon={solid('spinner')} spin />
                Tracking...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={solid('location-arrow')} />
                Track Shipment
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  )
}

export default Tracker
